export const BUSINESS = {
  name: "Savage Cleaning",
  phone: "0416 238 430",
  phoneRaw: "0416238430",
  email: "info@savagecleaning.com",
  region: "Brisbane, Gold Coast & South East Queensland",
  regionShort: "South East Queensland",
  tagline:
    "Savage Cleaning delivers professional commercial cleaning solutions that businesses trust, builders recommend and property managers rely on.",
  hours: [
    { day: "Monday – Friday", time: "7:00 AM – 6:00 PM" },
    { day: "Saturday", time: "8:00 AM – 4:00 PM" },
    { day: "Sunday", time: "By appointment" },
  ],
  serviceAreas: [
    "Brisbane",
    "Gold Coast",
    "Sunshine Coast (by quotation)",
    "South East Queensland",
  ],
};

export const SERVICES = [
  {
    slug: "commercial",
    title: "Commercial Cleaning",
    tagline: "Our core focus. Systems built for commercial environments.",
    short:
      "Professional commercial cleaning contracts for offices, medical, education, retail, industrial and government facilities across South East Queensland.",
    featured: true,
  },
  {
    slug: "builders",
    title: "Builders' Final Cleans",
    tagline: "Handover-ready presentation, every time.",
    short:
      "Comprehensive final cleans for newly completed homes, apartment complexes and commercial developments — ready for settlement, handover or occupancy.",
  },
  {
    slug: "bond",
    title: "Bond & End of Lease",
    tagline: "Top-to-bottom, inspection-ready cleans.",
    short:
      "Professional bond cleans for tenants, landlords, real-estate agencies and property managers — designed to maximise bond return outcomes.",
  },
  {
    slug: "residential",
    title: "Residential Cleaning",
    tagline: "Selected residential work, same commercial standard.",
    short:
      "Selected residential cleaning for homeowners who value professional workmanship, reliability and exceptional attention to detail.",
  },
];
